module.exports = __webpack_public_path__ + "img/latestBg.4d8d7c7e.png";